import {useQuery} from '@tanstack/react-query';
import {rqCreateSearchRequest} from '@app/reactQuery/apis/rqHttpsUtils';
import {RQ_GET_SECONDARY_COMPLIANCE_REPORTS_API} from '@app/reactQuery/apis/constants';

export const RQUseGetSecondartComplianceReportsData = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_secondart_compliance_reports_data', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, yearMonth} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_SECONDARY_COMPLIANCE_REPORTS_API,
        null,
        certificate,
        {yearMonth: yearMonth},
        signal,
      );
    },
    ...options,
  });
};
